import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-cambiar-nota',
  templateUrl: './modal-cambiar-nota.component.html',
  
})
export class ModalCambiarNotaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-cambiar-nota/modal-cambiar-nota.component.ts